var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9696A4","fillRule":"nonzero","d":"M10.2 4.666h-.6v-1.16C9.62 1.59 8.04.02 6.07 0H5.97C4.013.002 2.422 1.535 2.4 3.437v1.23h-.6c-.994 0-1.8.783-1.8 1.75v5.833C0 13.217.806 14 1.8 14h8.4c.994 0 1.8-.783 1.8-1.75V6.416c0-.966-.806-1.75-1.8-1.75zm-3.6 7H5.4v-1.274c-.827-.284-1.322-1.106-1.174-1.946.148-.84.897-1.453 1.774-1.453s1.626.613 1.774 1.453c.148.84-.347 1.662-1.174 1.946v1.275zm1.8-7H3.6V3.448c.014-1.263 1.071-2.28 2.37-2.282h.083c.63.006 1.231.256 1.672.694.44.437.683 1.028.675 1.64v1.166z"}));
}

Lock.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14"};

module.exports = Lock;

Lock.default = Lock;
